export default __webpack_public_path__ + "static/media/MovieRecommender.8e9b470e.jpg";